import useReveal from '../hooks/useReveal';


import "./styles/about.css" 

export default function About() {
    const ref = useReveal();
    return (
        <section ref={ref} id="about" className="section">
            <h1 className="reveal">About Me {"{"}</h1>
            <div className="about-container reveal-group">
                <div id="about-left-container">
                    <p>I just really like computers and problem-solving.
                    <br></br>
                    I also laaaaaaaahv cars.
                    </p>
                    <figure>
                        <img src="/car.jpg" alt="Blue car" id="car"></img>
                        <figcaption>This is my 2006 Acura RSX by the way.. <span>{"(📸 @pmokk on Instagram)"}</span></figcaption>
                    </figure>
                </div>
                <div>
                    <p> Driven by a passion for computer sciences for over a decade, I have spent years refining my skills through formal education and side projects.
                    <br></br>
                    <br></br>
                    My love for computers and technology has grown into a hunger for continuous learning and being better than I was yesterday.
                    <br></br>
                    <br></br>
                    Moments are more enjoyable with others. In my pursuit for knowledge in the tech space, I learn and continue to build on my skills as a team player.
                    </p>
                </div>
            </div>
            <h1 className="reveal"> {"}"} </h1>
        </section>
    );
}
